import { Reveal } from "./Reveal";
import { Formline } from "./Formline";

const PARAGRAPHS = [
  "At Chowat Security Services Inc., we believe security is about more than protecting property — it is about protecting people, earning trust, and building lasting relationships with the communities we serve.",
  "As a 100% Indigenous-owned and operated security company, we provide professional security services founded on integrity, accountability, respect, and a commitment to excellence. Every assignment we undertake is approached with the understanding that our clients are placing their confidence in us to safeguard what matters most.",
  "Our company was founded on the belief that strong communities are built through opportunity, respect, and responsible leadership. Guided by Indigenous values and professional standards, we strive to create safe environments where businesses, employees, and communities can thrive together.",
];

const WHO_WE_ARE = [
  "Our leadership brings lived experience, cultural understanding, and a lifelong connection to Indigenous communities. Those experiences have shaped the way we lead — with humility, respect, and a commitment to treating every person with dignity.",
  "We understand the importance of building respectful relationships with Indigenous communities, governments, and industry partners. Our knowledge of Indigenous traditions, community engagement, and the legal and cultural considerations associated with projects on or near Indigenous and federally regulated lands allows us to work collaboratively while recognizing the unique values and governance of the communities involved.",
];

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="relative py-24 md:py-32 overflow-hidden"
  >
    <Formline className="absolute -left-24 top-16 w-[380px] h-[380px]" opacity={0.05} />
    <Formline className="absolute -right-20 bottom-0 w-[320px] h-[320px] -rotate-12" opacity={0.04} />

    <div className="relative mx-auto max-w-7xl px-5 md:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <span className="text-xs font-bold uppercase tracking-[0.24em] text-[color:var(--primary-text)]">
            About Us
          </span>
          <h2 className="mt-5 font-display text-4xl md:text-6xl tracking-tight leading-[0.95]">
            About Chowat Security{" "}
            <span className="font-editorial italic">Services Inc.</span>
          </h2>
          <p className="mt-8 font-display text-xl md:text-2xl leading-snug text-white/90">
            Protecting People. Building Trust.{" "}
            <span className="text-[color:var(--primary-text)]">Honouring Community.</span>
          </p>
          <span className="mt-8 block h-px w-24 bg-[color:var(--primary)]" />
        </Reveal>

        <div className="lg:col-span-7 space-y-7">
          {PARAGRAPHS.map((p, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <p
                data-testid={`about-paragraph-${i + 1}`}
                className="text-lg md:text-xl text-secondary leading-relaxed"
              >
                {p}
              </p>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-20 md:mt-28 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 border-t border-white/10 pt-16 md:pt-20">
        <Reveal className="lg:col-span-5">
          <span className="text-xs font-bold uppercase tracking-[0.24em] text-[color:var(--primary-text)]">
            Who We Are
          </span>
          <h3 className="mt-5 font-display text-3xl md:text-5xl tracking-tight leading-[0.95]">
            Rooted in <span className="font-editorial italic">Indigenous Values</span>.
          </h3>
          <span className="mt-8 block h-px w-24 bg-[color:var(--primary)]" />
        </Reveal>

        <div className="lg:col-span-7 space-y-7">
          {WHO_WE_ARE.map((p, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <p
                data-testid={`who-we-are-paragraph-${i + 1}`}
                className="text-lg md:text-xl text-secondary leading-relaxed"
              >
                {p}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
